import { Record } from 'immutable';
import { schema } from 'normalizr';

import { authGroupSchema } from '@sophocles/entities/AuthGroup';
import { customerSchema } from '@sophocles/entities/Customer';
import { siteGroupSchema } from '@sophocles/entities/SiteGroup';
import { userOptionSchema } from '@sophocles/entities/UserOption';

export const User = new Record({
  id: null,
  customer: null,
  last_login: null,
  is_superuser: false,
  email: 'N/A',
  first_name: 'N/A',
  last_name: '',
  is_staff: false,
  date_joined: null,
  is_active: null,
  all_sitegroups_user: null,
  site_groups: [],
  groups: [],
  applications: [],
  options: {},
  must_change_password: false,
  has_usable_password: null,
  legacy_auth: null,
});

export const userSchema = new schema.Entity('users', {
  options: userOptionSchema,
  site_groups: [siteGroupSchema],
  customer: customerSchema,
  groups: [authGroupSchema],
});

export const LimitedUser = new Record({
  id: null,
  customer: null,
  first_name: 'N/A',
  last_name: '',
  is_active: null,
});
